import data from "../../.sourceflow/landing_pages.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const landing_pages_helper = new CollectionHelper(data);
